//
import { ProductModel } from '@/models'

/**
 *
 */
const fetchById = async id => {
    //
    const includes = [
            'wh_subfamily',
            'wh_product_upc_code',
            'wh_item',
            'wh_tags',
        ],
        appends = [
            'sale_prices', 
            'branch_offices',
            'last_purchase_price',
            'last_purchase_provider',
        ]

    //
    try {
        //
        let user = await ProductModel.include(includes)
            .append(appends)
            .find(id)

        //
        return user
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchById
